import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useProtestEventsStore } from "./stores/protest-events";
import TheNavBar from "./components/TheNavBar.vue";
import TheFooter from "./components/TheFooter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const protestEventStore = useProtestEventsStore();

const isLoading = ref<boolean>(true);

onMounted(async () => {
  try {
    await protestEventStore.fetchProtestEvents();
  } finally {
    isLoading.value = false;
  }
});

return { __sfc: true,protestEventStore, isLoading, TheNavBar, TheFooter }
}

})